import React, { useEffect, useState } from 'react'
import { Horizontal } from '@gravitate-js/excalibrr'
import { IntradayProgressBar } from '@components/Reports/DispatchDirective/DirectiveStatus/Intraday/IntradayProgressBar'
import { useDirectiveContext } from '@components/Reports/DispatchDirective/DirectiveContext'
import { DirectiveDeltaTag } from '../../DirectiveDeltaTag'
export const IntradayStatusRow = ({ directive }) => {
  const { viewingPlanned } = useDirectiveContext()
  const [delta, setDelta] = useState(directive.delta_to_directive)
  useEffect(() => {
    const newDelta = viewingPlanned ? directive.delta_to_directive : directive.delta_without_planned
    setDelta(newDelta)
  }, [viewingPlanned, directive])

  return (
    <Horizontal height={30}>
      <Horizontal className='pr-3 pt-2' flex={1}>
        <IntradayProgressBar barHeight={15} directive={directive} showPlanned={viewingPlanned} />
        <DirectiveDeltaTag delta={delta} />
      </Horizontal>
    </Horizontal>
  )
}
